import * as React from "react";

import {
  Edit,
  SimpleForm,
  EditProps,
  TextInput,
  required,
} from "react-admin";

import {updateUserIdentification} from './index'


const validateRequired = [required('مقدار را وارد کنید')];


export const UserIdentificationEdit = (props: EditProps): React.ReactElement => {  

    const save = async (values: any) => {
        console.log('save values: ', values)
        updateUserIdentification(values).then(res => {
            window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/UserIdentificationLinkExcel`
        })
    }

  return (
    <Edit {...props}>
      <SimpleForm style={{ direction: 'rtl' }} save={save}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
            <TextInput type="date" validate={validateRequired} isRequired style={{width: '100%'}} source="expirationDate" label="تاریخ انقضا" />                               
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput style={{width: '100%'}} source="utmCampaign" label="کمپین" />
                    <TextInput style={{width: '100%'}} source="utmMedium" label="مدیوم" />
                    <TextInput style={{width: '100%'}} source="utmSource" label="سورس" />
                </div>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
            <TextInput validate={validateRequired} isRequired style={{width: '100%'}} source="targetPageAddress" label="لینک صفحه هدف" />
        </div>                                                                        
      </SimpleForm>
    </Edit>
  );
};
